import BaseApi from "./BaseApi";
import Cookies from 'js-cookie';

export default class JobsPlanner extends BaseApi{
    construct() {}

    static async search(params) {
            return JobsPlanner.startRequest().then(() => {
                let csrfToken = Cookies.get('XSRF-TOKEN')
                let url = JobsPlanner.getApiUrl();
    
                const headers = {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                };
    
                return JobsPlanner.getAxiosInstance().get(url, {params: params}, {headers});
            });
        }

    static async create(data) {
        return JobsPlanner.startRequest().then(() => {
            let csrfToken = Cookies.get('XSRF-TOKEN');

            let url = JobsPlanner.getApiUrl();

            const headers = {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': csrfToken,
            };

            return JobsPlanner.getAxiosInstance().post(url, data, { headers });
        });
    }

    static async delete(id) {
        return JobsPlanner.startRequest().then(() => {
            let csrfToken = Cookies.get('XSRF-TOKEN')

            let url = JobsPlanner.getApiUrl() + id;

            const headers = {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': csrfToken,
            };

            return JobsPlanner.getAxiosInstance().delete(url, {headers});
        });
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/jobsplanner/";
    }
}